<template>
  <div>
    <div @click="openModal" class="watch-container text-center">
      <div class="amount" v-if="watch.amount !== undefined">
        {{ watch.amount }}
      </div>
      <div class="image">
        <ImageItem class="article-item__image" :source="watchImage" v-if="watchImage !== ''" />
      </div>
      <div class="brand">{{ watch.brand }}</div>
      <div class="model">{{ watch.model }}</div>
      <div v-if="watchReferenceNumber !== ''" class="secondary-information">
        {{ watchReferenceNumber }}
      </div>
      <div class="secondary-information" v-if="watch.year !== undefined && watch.condition !== undefined">
        {{ watch.year }} ({{ watch.condition }})
      </div>
      <div class="offer-price" v-if="watch.offerPrice !== undefined">{{ watch.offerPrice }} EUR</div>
      <div>
        <div class="btn btn-sm btn-xs btn-primary">{{ btnText }}</div>
      </div>
    </div>
    <watch-detail-modal
      @close="closeModal"
      v-if="showModal"
      :watch="watch"
      :type="type"
      :btn-text="btnText"
    ></watch-detail-modal>
  </div>
</template>

<script>
import WatchDetailModal from 'Components/WatchDetailModal';
import ImageItem from 'Components/common/ImageItem';

export default {
  name: 'WatchInGrid',
  components: {
    WatchDetailModal,
    ImageItem,
  },
  props: {
    watch: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    btnText: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      showModal: false,
    };
  },
  computed: {
    watchImage() {
      return encodeURI(
        this.watch.image !== undefined
          ? this.watch.image
          : this.watch.imageUrl !== undefined
          ? this.watch.imageUrl
          : '',
      );
    },
    watchReferenceNumber() {
      return this.watch.reference !== undefined
        ? this.watch.reference
        : this.watch.referenceNumber !== undefined
        ? this.watch.referenceNumber
        : '';
    },
  },
  methods: {
    openModal() {
      this.showModal = true;
      this.$ga.event({
        eventCategory: this.type === 'watch' ? 'B2BOverview' : 'DemandOverview',
        eventAction: this.type === 'watch' ? 'click_watch' : 'click_demand',
        eventLabel:
          this.type === 'watch'
            ? 'Open WatchDetail for watch ' + this.watch['itemId']
            : 'Open DemandDetail for demand ' + this.watch['itemId'],
      });
    },
    closeModal() {
      this.showModal = false;
      this.$ga.event({
        eventCategory: this.type === 'watch' ? 'WatchDetail' : 'DemandDetail',
        eventAction: this.type === 'watch' ? 'click_watch_background' : 'click_demand_background',
        eventLabel:
          this.type === 'watch'
            ? 'Close WatchDetail for watch ' + this.watch['itemId']
            : 'Close DemandDetail for demand ' + this.watch['itemId'],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.watch-container {
  padding: 10px;
  text-align: center;

  .brand {
    text-transform: uppercase;
  }

  .secondary-information {
    color: #777777;
    word-break: break-all;
    @media all and(max-device-width: 576px) {
      font-size: 0.8rem;
    }
  }

  .btn-xs {
    border-radius: 0.3rem;
    font-size: 0.8rem;
    padding: 2px 6px;
  }

  .image {
    display: inline-block;
    height: 120px;
    width: 90px;

    img {
      width: 100%;
      height: auto;
    }
  }

  .amount {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    text-align: right;
    padding-right: 5px;
    color: var(--white);
    width: 50px;
    font-size: 14px;
    line-height: (40 / 14);

    &::before {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 70px 70px 0;
      border-color: transparent var(--primary) transparent transparent;
      z-index: -1;
    }

    &::after {
      content: ' x';
    }
  }
}
</style>
